import { DeviceType } from '@/app/components/DeviceSelectionGallery/DeviceSelectionGallery.types'
import { ThermostatBrand } from '@/types/brand'
import { ThermostatBrandName } from '@/types/thermostatBrands'
import { match, P } from 'ts-pattern'

/**
 * Returns the thermostat brand list with Ecobee hidden unless the user is
 * actively in the multi-program enrollment flow AND the selected MP program
 * supports thermostats. Nest and Honeywell are always preserved.
 */
export function filterThermostatBrandsForMPFlow(
  brands: ThermostatBrand[],
  inFlow: boolean,
  deviceTypes: 'all' | DeviceType[],
  isLoadingOrIdle: boolean,
): ThermostatBrand[] {
  const ecobeeAllowed = match({ inFlow, deviceTypes, isLoadingOrIdle })
    .with({ inFlow: false }, () => false)
    .with({ isLoadingOrIdle: true }, () => false)
    .with({ deviceTypes: 'all' }, () => false)
    .with({ deviceTypes: P.array(P.string) }, ({ deviceTypes }) =>
      deviceTypes.includes('thermostat'),
    )
    .exhaustive()

  if (ecobeeAllowed) {
    return brands
  }
  return brands.filter((brand) => brand.id !== ThermostatBrandName.Ecobee)
}
